import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";
import Warning from "TaskDialogCommon/Warning";

export const StringSelect = (props) => {
  const {
    label,
    param,
    taskConfig,
    optionObject,
    setTaskConfigChanges,
    valueParser = (k, v) => v,
    labelParser = (k, v) => k,
    warning,
  } = props;

  //for object key is key
  // for array key is index
  const options = Object.keys(optionObject).map((key) => {
    const value = optionObject[key];
    return {
      label: labelParser(key, value),
      value: valueParser(key, value),
    };
  });

  return (
    <div style={{ marginTop: "10px" }}>
      <div>
        <span style={{ float: "left", marginBottom: "10px" }}>{label}</span>
      </div>
      <div>
        <AngSelect
          ng-model={taskConfig[param]}
          options={options}
          onChange={({ value }) => {
            setTaskConfigChanges({ [param]: value });
          }}
        />
      </div>
      {warning && <Warning>{warning}</Warning>}
    </div>
  );
};
